import React, {useContext, useEffect} from 'react';
import {
    TrackingContext,
    TrackingContextValue,
} from '@homeaway/react-event-tracking';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import classnames from 'classnames';
import './FilterPill.less';
import {GENERIC_EVENT} from '../../utils/edap';

interface FilterPillProps {
    label?: string;
    leftAlign?: boolean;
    icon?: string;
    applied?: boolean;
}

const FilterPill = ({
    label = '',
    leftAlign = false,
    icon,
    applied = false,
}: FilterPillProps) => {
    const edapContext: TrackingContextValue = useContext(TrackingContext);

    useEffect(() => {
        const eventFields = {
            eventcategory: 'filter',
            eventaction: 'filter group presented',
            eventlabel: label,
        };
        edapContext.trigger(GENERIC_EVENT, eventFields);
    }, []);

    function handleClick(): void {
        const eventFields = {
            eventcategory: 'filter',
            eventaction: 'click',
            eventlabel: label,
        };
        edapContext.trigger(GENERIC_EVENT, eventFields);
    }

    const svgIcon = <SVGIcon inlineFlex markup={icon} aria-hidden />;

    const className = classnames('FilterPill', {
        'FilterPill--applied': applied,
    });

    return (
        <Button
            className={className}
            size="xs"
            onClick={handleClick}
            label={
                <>
                    {leftAlign && svgIcon}
                    <span>{label}</span>
                    {!leftAlign && svgIcon}
                </>
            }
        />
    );
};

export default FilterPill;
export {FilterPill};
